export const PRE_SALES_LISTING = "PRE_SALES_LISTING";
export const STATUS_LIST = "STATUS_LIST";
export const DEAL_STATUS_LIST = "DEAL_STATUS_LIST";
export const UPDATE_LEAD_STATUS = "UPDATE_LEAD_STATUS";
export const FILTER_DROPDOWN_LIST = "FILTER_DROPDOWN_LIST";
export const FETCH_ZONES_LIST = "FETCH_ZONES_LIST";
export const VIEW_DETAILS = "VIEW_DETAILS";
export const VIEW_CONTRACT = "VIEW_CONTRACT";
